// Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
import axios from '../../libs/cifra/axios';

const URL_BASE = '/gestion_economica/generar_suscripciones';

export default {
  infoSuscripcion(idAlumno, idModalidad, options) {
    const opts = options || {};
    const defaultParams = {
      alumno_id: idAlumno,
      modalidad_id: idModalidad,
    };
    opts.params = Object.assign(defaultParams, opts.params);
    return axios.get(`${URL_BASE}/info_suscripcion`, opts);
  },
  infoSuscripciones(idsAlumnos, idModalidad, options) {
    const json = {
      alumno_ids: idsAlumnos,
      modalidad_id: idModalidad,
    };
    return axios.post(`${URL_BASE}/info_suscripciones`, json, options);
  },
  buscarAlumnos(options) {
    return axios.get(`${URL_BASE}/alumnos`, options);
  },
  buscarAlumnosExcel(fichero) {
    const formData = new FormData();
    formData.append('fichero', fichero);

    return axios.post(`${URL_BASE}/alumnos_excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  generar(infoServicio, suscriptores, options) {
    const json = {
      infoServicio,
      suscriptores,
    };
    return axios.post(URL_BASE, json, options);
  },
};
